import Controller from "./bookings.controller";
import template from "./bookings.html";

const bookingsPage = {
  template,
  controller: Controller,
  bindings: {
    user: "<",
  },
};

export default bookingsPage;



// WEBPACK FOOTER //
// ./src/pages/bookings/bookings.component.js